(function(){    var loadScript = function(url, callback){   var script = document.createElement("script"); script.type = "text/javascript"; if (script.readyState){ script.onreadystatechange = function(){ if (script.readyState == "loaded" || script.readyState == "complete"){  script.onreadystatechange = null;   callback(); } }; } else { script.onload = function(){ callback(); }; } script.src = url;    document.getElementsByTagName("head")[0].appendChild(script); }; var fix = function($){
    var ml_lang;
    var listen = false;

    var ml_domains_local;

    function interceptCartSubmit()
    {
        $('form[action=\\/cart] input[name=checkout],form[action=\\/cart] button[name=checkout], a[href=\\/checkout]').click(function(e)
        {
            e.preventDefault();
            location.href='/checkout?locale='+ml_lang;

        });
    }

    function setCookie(v)
    {
        document.cookie = "redirected="+v+"; path=/;";
    }

    function delCookie()
    {
        document.cookie = "redirected=; path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC";
    }

    function getCookie() 
    {
        var name = "redirected=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) 
        {
            var c = ca[i];
            while (c.charAt(0)==' ') 
                c = c.substring(1);
            
            if (c.indexOf(name) == 0) {   return c.substring(name.length,c.length);      }
        }
        return "";
    }
        
    function swap(json)
    {
        var ret = {};
        for(var key in json)
            ret[json[key]] = key;
  
        return ret;
    }   
        
    function getUrlVars(domains)
    {   
        var vars = []; 
        var domain_flag = false;
        var jvars = {};
        var hash;
        
        if(typeof domains === 'undefined')
            var domains = {};

        var d = swap(domains);
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        var cloc =  window.location.host;       
        for(var domain in d)
        {
            if(cloc == domain)
            {           
                jvars['lang']=d[domain];
                domain_flag=true; 
            }
        }
                            
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            if(hash[1]!=null) 
                jvars[hash[0]] = hash[1];
        }
        return jvars;
    }
    
    
    function setAtt(vals,target,ml_dom)
    {

        var url = location.href.split('?'); 
        if(url[0].charAt(url[0].length-1) =='#')
            url[0]=url[0].substr(0,url[0].length-1);
        var new_qs_arr = [];
        var new_qs = '';
        var qs = getUrlVars(ml_dom);
    
        for(var j=0; j< qs.length; j++)
        {
            if(qs[j]!='lang')
                new_qs_arr.push(qs[j]+'='+qs[qs[j]]);
        }
        new_qs = new_qs_arr.join('&');
        if(new_qs.length>0)
            new_qs = '?'+new_qs;
        var dest = '';

        if(typeof ml_dom === 'undefined')
            var ml_dom = {};

        var path = window.location.pathname;
        var update_url = '';

        if(ml_dom[target]!=null)
        {
            update_url = 'https://'+ml_dom[target];
            dest ='https://'+ml_dom[target]+path+new_qs; 
        }
        else
        {
            update_url = 'https://'+location.host;
            dest =url[0]+new_qs;  
        }
        update_url = update_url+'/cart/update?attributes[ml_lang]='+target;
        $('body').append('<iframe src="'+update_url+'" style="display:none;" id="ml_cart_update"></iframe>');
        //$('#ml_cart_update').load(update_url,function(){location.href = dest; });

        $('#ml_cart_update').on('load',function(){ location.href = dest; });
        return;

    }   
    
    function getLang()
    {
        $.ajax({    
            url  : '/cart.js',
            type : 'GET',
            crossDomain: false,
            dataType:'json',
            success : function(data) 
            {   
                ml_lang = data['attributes']['ml_lang'];
                if(ml_lang==null)
                    ml_lang=def_loc;
                                        
                var bidi = ['ar','fa','ur','he','he-IL']; 
                if( bidi.indexOf(ml_lang)>=0  && ($('.ml_lang_selector').attr('rtl') == 'rtl'))
                {
                    $('html').attr('dir','rtl');
                    $('html').addClass('rtl');
                }   
                else
                {
                    $('html').removeAttr('dir');
                    $('html').removeClass('rtl');
                }
                    
                var redirect =  $('.ml_lang_selector').attr('redirect');
                if(redirect===null)
                    redirect =  'off';
                    
                if(redirect!='off')
                {    

                    var br_locale = 'en-gb,en-ca;q=0.9,en;q=0.8,fr-ca;q=0.7,fr;q=0.6';
                    var br_locale_short = 'en';
                    
                    var l_loc = new Array();        
                    var target='';
                    var keys = Object.keys(ml_loc);
                    for(var i=0;i< keys.length;i++)
                        l_loc.push(keys[i].toLowerCase());
                    
                    if(l_loc.indexOf(br_locale) >=0 )
                        target = keys[l_loc.indexOf(br_locale)];
                    else if(l_loc.indexOf(br_locale_short) >=0 )
                        target = keys[l_loc.indexOf(br_locale_short)];
                    var t = location.href.split('#')[0]
                    t = t.split('?')[0]+'?lang='+target;

                    if(redirect=='once' && target != '' && target==ml_lang && getCookie().length==0)
                    {
                        setCookie('once');
                        return;
                    }					
                    if(redirect=='once' && target != '' && target!=ml_lang && getCookie().length==0)
                    {
                        setCookie('once');
                        setAtt('attributes[ml_lang]='+target,target,ml_domains_local);
                        return;
                    }
                    else if(redirect=='force' && target != '' && target!=ml_lang)
                    {
                        setAtt('attributes[ml_lang]='+target,target,ml_domains_local);
                        return;
                    }                       
                                                                
                }
                $('#ml_switch_loc,#ml_custom_switch').val(ml_lang);


                var type = $('.ml_lang_selector').attr('type');
                if(typeof type=='undefined')
                    type ='';
                if(type.indexOf('flag_')==0)
                    triggerFlagSelect($('.lang_tab[value='+ml_lang+']'),false);
        
                var qs = getUrlVars(ml_domains_local);

                if ('lang' in qs && ml_lang != qs['lang'])
                    setAtt('attributes[ml_lang]='+qs['lang'],qs['lang'],ml_domains_local);

                $('.ml_lang_selector').show();
                    
            },
            error : function(request,error)
            {
            }
        });
    }       
    

    function createFlagDropdown()
    {
        $('head').append('<link rel="stylesheet" href="//cdn.shopify.com/s/assets/locale_flag_dropdown.css" type="text/css">');
        var sel = $('.ml_lang_selector');
        sel.css('direction','ltr');
        sel.hide();
        var has_txt = true;
        var width_class = 'ml_lang_texts_long';
        if (sel.attr('type')=='flag_no_txt_dropdown')
        {
            has_txt = false;
            width_class= 'ml_lang_texts_short';
        }
        sel.append('<div><div class="ml_button"></div><ul class="ml_select-list '+width_class+'"></ul><div>');    
        $('.ml_lang_selector select option').each(function() {  
            var bg = $(this).attr('flag');    
            var dd_txt = $(this).text();
            if(!has_txt)
                dd_txt='';

            $('.ml_select-list').append('<li class="clsAnchor"><span class="lang_tab '+width_class+'" flag="'+bg+'" value="' + $(this).val() + '" style="background-image:url('+bg+')">' + dd_txt + '</span></li>');   
        });    
        
        $('.ml_lang_selector .ml_button').html('<span class="'+width_class+'" style="background-image:url(' + $('#ml_switch_loc option:selected').attr('flag') + ')">' + 
        $('#ml_switch_loc option:selected').text() + '<a href="javascript:void(0);" class="ml_select-list-link"></a></span>');   

        var sel_val = $('#ml_switch_loc option:selected').val();
        $('.ml_lang_selector ul li span[value='+sel_val+']').addClass('active');

        $('.ml_lang_selector .ml_select-list span').click(function()
        {          
            triggerFlagSelect($(this),true);

        });       
        $('.ml_lang_selector .ml_button').on('click','a.ml_select-list-link', function()
        {      
            $('.ml_lang_selector ul li').slideToggle();  
        });     
    
    }

    function triggerFlagSelect(t,fire)
    {
        t.hide();
        var width_class = 'ml_lang_texts_long';
        if ($('.ml_lang_selector').attr('type')=='flag_no_txt_dropdown')
        {
            has_txt = false;
            width_class= 'ml_lang_texts_short';
        }   
        var dd_text = t.text();
        var dd_img = t.attr('flag'); 
        var dd_val = t.attr('value');   
        $('.ml_lang_selector .ml_button').html('<span class="'+width_class+'" style="background-image:url(' + dd_img + ')">' + dd_text + '<a href="javascript:void(0);" class="ml_select-list-link"></a></span>');      
        $('.ml_lang_selector .ml_select-list span').parent().removeClass('active');    
        t.parent().addClass('active');     
        $('#ml_switch_loc').val( dd_val ); 
        $('.ml_lang_selector .ml_select-list li').slideUp();  
        if(fire)
            $('#ml_switch_loc').change();
    }


    function inspectDOM()
    {
        $('body').off();
        if(typeof ml_opts === 'undefined' && typeof ml_frontend_replace  === 'undefined')
            return;
        
        if($('.single-option-selector-product').length || $('.single-option-selector').length || $('.single-option-radio').length || typeof ml_frontend_replace  != 'undefined')
        {   
            window.setTimeout(translateOptions,500);
            window.setTimeout(translateFrontendVars,500);
            window.setTimeout(attachDOMChangeListener,1000);
        }
    }

    function attachDOMChangeListener()
    {
        $('body').on("DOMSubtreeModified",function(){inspectDOM()});
    }

    window.MLupdateProductOptions = function(){
        translateOptions();
    };

    window.MLtranslateFrontendVars = function(){
        console.log('translate');
        translateFrontendVars();
    };

    function translateOptions()
    {   

        if(typeof ml_opts  === 'undefined')
            return;

        var opt_key_val = {};
        var opt_labels = {};

        var ok = Object.keys(ml_opts);
        for(var i=0;i < ok.length ;i++)
        {
            var trans_opts = JSON.parse(ml_opts[ok[i]]); 

            if(trans_opts===null)
                trans_opts = {};
            var trans_opts_keys = Object.keys(trans_opts);
            for(var j=0;j < trans_opts_keys.length;j++)
            {
                if(trans_opts_keys[j]!='ml_trans')
                    opt_key_val[trans_opts_keys[j]] = trans_opts[trans_opts_keys[j]];
                else
                {
                    if(trans_opts_keys[j]!='')
                        opt_labels[ok[i]] = trans_opts[trans_opts_keys[j]];
                }
            }
        }   
                
        listen = true;

        $('.single-option-selector,.single-option-radio,.single-option-selector-product,.single-option-radio').each(function(){ 
            var par = $(this).closest('div:has(label)');    
            var opt_name = '';          
            opt_name = $('label',par).first().text();           
            opt_name = $.trim(opt_name);
            opt_name = opt_name.replace(/\s/g,'_');     

            if(opt_labels[opt_name])
            {
                $('label',par).first().text(opt_labels[opt_name]);
                $('span.option-selector__label',par).first().text(opt_labels[opt_name]+':');                
            }
                            

            $('option,label,li',this).each(function(){

                //$(this).attr('default_txt', $(this).text());
                var co = $(this).html();
                co = co.trim();
                co = co.replace(/&amp;/g,'&');  

                if(opt_key_val[co])
                    $(this).text(opt_key_val[co]);

            });
            var st = $('option:selected',this).text();
            $('.selected-text',par).first().text(st);

        });



        /* custom option replacements */
        $('.ml_option,.ml_selected_option').each(function(){

            var co = $(this).html();
            co = co.trim();
            co = co.replace(/&amp;/g,'&');  

            if(opt_key_val[co])
                $(this).text(opt_key_val[co]);
        });
        
        $('.ml_opt_label').each(function(){
            var cust_opt_name = $.trim($(this).text());
            cust_opt_name = cust_opt_name.replace(/\s/g,'_');   

            if(opt_labels[cust_opt_name])
                $(this).text(opt_labels[cust_opt_name]);

        });
        listen=false;
    }


    function translateFrontendVars(node)
    {
        if(typeof ml_frontend_replace  === 'undefined')
            return;

        listen=true;
        if(node==null)
            node = $('body');

        var keys = Object.keys(ml_frontend_replace);


        node.contents().each(function(){
            var tname = this.tagName;
            if(tname!=null)
            {
                if(  tname.toUpperCase() =='IFRAME' )
                    return;         
            }

        $(this).contents().filter(function() {
            return this.nodeType == 3
        }).each(function(){
                    var txt = this.textContent;
                    txt = txt.trim();
                    for(var i=0;i < keys.length;i++)
                    {
                        if(txt=='')
                            continue;

                        //if(txt.indexOf(keys[i])>=0)
                        if(txt == keys[i])
                            this.textContent = this.textContent.replace(keys[i],ml_frontend_replace[keys[i]]);
                    }
                });


                if( $(this).children().length > 0 )
                    translateFrontendVars( $(this) );

        });

        listen=false;
    }

    function preloadImage(url)
    {
        var img=new Image();
        img.src=url;
    }
    
    $(document).ready( function()
    {   
        ml_domains_local = ml_domains;

        $('.ml_lang_selector').hide();
        var keys = Object.keys(ml_loc);
        keys.sort();
        var sel = $('.ml_lang_selector');
        sel.css('justify-content','flex-end');
        sel.css('display','flex');
        sel.css('float','none');
        var pos = sel.attr('position');
        var type = sel.attr('type');
        if(typeof type=='undefined')
            type = '';
        if(typeof pos=='undefined')
            pos = '';
        var version = sel.attr('version');

        var st = '';

        st = ' style="max-width:300px;"';
        var s = '';
        var link_arr = new Array();

        for(var j=0;j < keys.length;j++)
        {
            var k = keys[j];
            var flag = k.toLowerCase().substr(-2);
            if(flag=='en')flag='gb';
            if(flag=='ar')flag='ae';
            if(flag=='ko')flag='kr';
            if(flag=='hi')flag='in';
            if(flag=='fa')flag='ir';
            if(flag=='el')flag='gr';    
            if(flag=='ja')flag='jp';    
            if(flag=='zh')flag='cn';    
            if(flag=='vi')flag='vn';    
            if(flag=='sv')flag='se';    
            if(flag=='da')flag='dk';    
            if(flag=='nt')flag='hk';    
            if(flag=='ns')flag='cn';
            if(flag=='uk')flag='ua';
            if(flag=='sq')flag='al';        
            if(flag=='ca')flag='es-ct';
            if(flag=='cs')flag='cz';
            if(flag=='et')flag='ee';
            if(flag=='he')flag='il';
            if(flag=='sr')flag='rs';

            if(typeof flag_overrides != 'undefined')
                if(flag_overrides[flag]!=null)flag=flag_overrides[flag];
            
            var lang_name = ml_loc[k];
            if(typeof lang_overrides != 'undefined')
                if(lang_overrides[k]!=null)lang_name=lang_overrides[k];                                                 
            
            
            preloadImage('//cdn.shopify.com/s/assets/'+flag+'.svg');

            var nl = location.href.split('?')[0];

            if(type=='flags')
                s+='<span id="'+k+'" class="ml_link" style="cursor:pointer;"><img style="width:30px;padding-left:5px;padding-right:5px;" src="//cdn.shopify.com/s/assets/'+flag+'.svg"></span>';
            else if(type=='links')
                link_arr.push('<a id="'+k+'" class="ml_link" style="cursor:pointer;">'+lang_name+'</a>');
            else if(type.indexOf('dropdown')>=0)
                s+='<option class="" flag="//cdn.shopify.com/s/assets/'+flag+'.svg" value="'+k+'">'+lang_name+'</option>';
        }
        
        if(type=='links')
            s = link_arr.join('&nbsp;|&nbsp;');
        
        if(type=='flags' || type=='links')
            sel.html(s);
        else if(type.indexOf('dropdown')>=0)
            sel.html('<select class="" id="ml_switch_loc"'+st+'>'+s+'</select>');
        if(type.indexOf('flag_')==0 )
            createFlagDropdown();


        if(pos.indexOf('fixed_')==0)    
        {
            sel.css('position','fixed');
            sel.css('z-index','99999999999');
            if(pos=='fixed_top_right')
            {
                sel.css('top','0');
                sel.css('right','0');
            }
            else if(pos=='fixed_top_left')
            {
                sel.css('top','0');
                sel.css('left','0');
            }
        } else
        {
            sel.css('z-index','99999999999');
            if(pos=='top_right')
            {
                sel.css('justify-content','flex-end');
                $('.ml_select-list').css('left','');
                $('.ml_select-list').css('right','0');
            }
            else if(pos=='top_left')
            {
                sel.css('justify-content','flex-start');
                $('.ml_select-list').css('right','');
                $('.ml_select-list').css('left','0');
            }
        }

        getLang();

        $('#ml_switch_loc,#ml_custom_switch').change(function(){
            var v= $(this).val();
            setAtt('attributes[ml_lang]='+v,v,ml_domains_local);
        });
        
        $('.ml_link').click(function(){             
            var v = $(this).attr('id');
            setAtt('attributes[ml_lang]='+v,v,ml_domains_local);
        });
    

        interceptCartSubmit();
        attachDOMChangeListener();  

});

};if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {loadScript("//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js", function(){   jQuery191 = jQuery.noConflict(true);fix(jQuery191);});} else {fix(jQuery);}})();    
